<app-expandable-error-alert
  [visible$]="hasAlerts$"
  [title]="'expandableAlerts.title' | fms"
  [footerTitle]="'expandableAlerts.footerTitle' | fms"
  [footerHtml]="'expandableAlerts.footerHtml' | fms"
>
  <p>{{ "expandableAlerts.message.fetchingError" | fms }}</p>
  <p>{{ "expandableAlerts.message.tryAgain" | fms }}</p>

  <stb-accordion [rebrand]="true">
    <stb-accordion-item [headerText]="'expandableAlerts.expansion.title' | fms">
      @for (alert of alerts$ | async; track alert.text.title) {
        <div class="error">
          <strong>{{ alert.text.title | fms }}</strong
          ><br />
          {{ alert.text.message | fms }}
        </div>
      }
    </stb-accordion-item>
  </stb-accordion>

  <button [rebrand]="true" [stbButton]="'secondary'" (click)="refresh()" data-trackid="link-button-refresh">
    {{ "expandableAlerts.refreshButton" | fms }}
  </button>
</app-expandable-error-alert>
